document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.wm-slider-wrapper').forEach((slider) => {

    const track = slider.querySelector('.wm-slider-track');

    if (!track) return;

    const prev = slider.querySelector('.wm-prev');
    const next = slider.querySelector('.wm-next');

    const scrollAmount = () => track.clientWidth * 0.85;

    if (next) {
      next.addEventListener('click', () => {
        track.scrollBy({
          left: scrollAmount(),
          behavior: 'smooth'
        });
      });
    }

    if (prev) {
      prev.addEventListener('click', () => {
        track.scrollBy({
          left: -scrollAmount(),
          behavior: 'smooth'
        });
      });
    }

  });

});